import { createFeatureSelector, createSelector } from '@ngrx/store';
import { MenuState } from './menu.state';

export const getMenuState = createFeatureSelector<MenuState>('menu');

export const getAppMenuItems = createSelector(
  getMenuState,
  (state: MenuState) => state.items
);
